import { render } from "./VouchersShopPage.vue?vue&type=template&id=3a7693b5&scoped=true"
import script from "./VouchersShopPage.vue?vue&type=script&lang=js"
export * from "./VouchersShopPage.vue?vue&type=script&lang=js"

import "./VouchersShopPage.vue?vue&type=style&index=0&id=3a7693b5&scoped=true&lang=css"
import "./VouchersShopPage.vue?vue&type=style&index=1&id=3a7693b5&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7693b5"]])

export default __exports__